import styled from 'styled-components';

export const DropdownWrapper = styled.div`
    position: relative;
    width: 260px;
`;

export const DropdownButton = styled.button<{ isOpen: boolean }>`
    width: 100%;
    padding: 14px 16px;
    font-size: 16px;
    text-align: left;
    border-radius: 12px;
    border: 1.5px solid #bfc6d1;
    background: #fff;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:focus {
        outline: none;
        border-color: #8b5cf6;
    }
`;

export const Chevron = styled.span<{ isOpen: boolean }>`
    border: solid #6b7280;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    transform: ${({ isOpen }) =>
        isOpen ? 'rotate(-135deg)' : 'rotate(45deg)'};
    transition: transform 0.2s ease;
`;

export const Menu = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    width: 100%;
    background: #f3f3f3;
    border-radius: 14px;
    padding: 8px 0;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    z-index: 10;
    max-height: 360px;
    overflow-y: auto;
`;

export const MenuItem = styled.div<{ active?: boolean }>`
    padding: 14px 18px;
    font-size: 18px;
    cursor: pointer;
    background: ${({ active }) => (active ? '#dfe3e8' : 'transparent')};

    &:hover {
        background: #e5e7eb;
    }
`;
